import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { messageService } from './messages/message.module';

// tslint:disable-next-line:max-classes-per-file
@Injectable({ providedIn: 'root' })
export class SignalRService {
  private hubConnection: signalR.HubConnection;

  public startConnection(authService) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Error)
      .withUrl('eventhub', {
        accessTokenFactory: () => authService.getAuthorizationHeaderValue().replace('Bearer ', ''),

        // Currently on INTEC-PJT, only Long Polling seems to work.
        // skipNegotiation: false, transport: signalR.HttpTransportType.LongPolling
      })
      .withAutomaticReconnect()
      .build();

    this.addMessageListener();

    // this.hubConnection.keepAliveIntervalInMilliseconds = 1000 * 5;  // Ping the server every 5 seconds - This keeps the server aware of this client (Client to Server)
    // this.hubConnection.serverTimeoutInMilliseconds = 1000 * 30;     // Terminate connection after 30 seconds of no contact with server (Server to Client)

    if (authService.isUserLoggedIn()) {
      this.hubConnection
        .start()
        .then(() => {
          console.log('Connection to event hub started');
        }
        )
        // .catch((err) => console.log('Error while starting connection: ' + err))
        ;
    }
  }

  public endConnection() {
    this.hubConnection
      .stop()
      .then(() => console.log('Connection to event hub stopped'))
      //.catch((err) => console.log('Error while stopping connection: ' + err))
      ;
  }

  public addMessageListener() {
    if (this.hubConnection) {
      this.hubConnection.on('Message', (msg) => {
        console.log('Message', msg);
        try {
          switch (msg.MessageType.trim().toLowerCase()) {
            case 'error':
              messageService.error(msg.Message, msg.Title);
              break;
            case 'information':
              messageService.info(msg.Message, msg.Title);
              break;
            case 'success':
              messageService.success(msg.Message, msg.Title);
              break;
            case 'warning':
              messageService.warning(msg.Message, msg.Title);
              break;
          }
        }
        catch { };

      });
    }
  }
}
